import { gql } from 'graphql-request';

export const CACHE_INVOICE_PAY_QUERY = gql`
  mutation CacheInvoicePay(
    $uuid: ID!
    $paymentMethod: String!
    $paymentDate: String
    $confirmationId: String
    $fileAttachmentId: ID
    $paid: Float
    $received: Float
    $transactionFeeExpense: Float
  ) {
    invoicePay(
      input: {
        uuid: $uuid
        paymentMethod: $paymentMethod
        paymentDate: $paymentDate
        confirmationId: $confirmationId
        fileAttachmentId: $fileAttachmentId
        paid: $paid
        received: $received
        transactionFeeExpense: $transactionFeeExpense
      }
    ) {
      appVersion
      errors {
        fullMessages
      }
      record {
        id
        nanoId
        uuid
      }
      recordId
      recordNanoId
      recordUuid
      status
    }
  }
`;
